'use strict';

angular.module('buyers')
.controller('TabsetController', ['$scope', function($scope) {
    $scope.tabs = [];
    var index = 1,
        prefix = 'tab_' + Math.random().toString(36).substring(7);


    /**
     *
     * @param {string} heading
     * @param {boolean=} opt_isActive
     * @return {number}
     */
    this.addTab = function(heading, opt_isActive) {
        var tab = {
            heading: heading,
            id: prefix + '_' + index,
            isActive: !!opt_isActive
        };

        index++;
        $scope.tabs.push(tab);

        return tab.id;
    };


    /**
     *
     * @param {number} id
     */
    this.removeTab = function(id) {
        var index = -1;

        $scope.tabs.forEach(function(tab, i) {
            if (tab.id == id)
                index = i;
        });

        if (index > -1)
            $scope.tabs.splice(index, 1);
    };
}])
.directive('tabset', ['$timeout', function($timeout) {
    /**
     * Template of directive.
     * @type {String}
     */
    var template =
        '<div class="tabset">' +
            '<div class="ui top attached tabular menu">' +
                '<a class="item" ng-repeat="tab in tabs" data-tab="{{tab.id}}"' +
                    ' ng-class="{active: tab.isActive}">{{tab.heading}}</a>' +
            '</div>' +
            '<div ng-transclude></div>' +
        '</div>';


    /**
     * Default options.
     * @type {Object}
     */
    var defaults = {
        extraClasses: []
    };


    /**
     * Linker function.
     */
    var link = function(scope, $element, attrs) {
        $element = $($element[0]);
        var options = $.extend(true, {}, defaults, scope.options || {});

        $timeout(function() {
            $element
                .find('.menu')
                .addClass(options.extraClasses.join(' '))
                .find('.item')
                .tab();
        });
    };


    return {
        restrict: 'E',
        scope: {
            options: '='
        },
        template: template,
        transclude: true,
        replace: true,
        controller: 'TabsetController',
        link: link
    };
}]);